import { render, staticRenderFns } from "./fidelior-areas.vue?vue&type=template&id=7b979d0b&"
import script from "./fidelior-areas.vue?vue&type=script&lang=js&"
export * from "./fidelior-areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports